import React, { useContext, useEffect } from 'react';
import { Divider, Empty, Typography } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import {
  WebChatChannels,
  WebChatChannelEditor,
} from '../../components/webChat';
import { useSelector } from 'react-redux';
import { showErrorToast } from '../../../../components/commonComponents/gxAntdToast/toastUtils';
import NotificationContext from '../../../../providers/NotificationProvider';
import {
  getUnassignedTeams,
  getWebChatChannelData,
} from '../../../../reduxToolkit/channelSlice';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
const { Title, Text } = Typography;

const WebChatChannel = () => {
  // hooks
  const toast = useContext(NotificationContext);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const channel = searchParams.get('channel');

  // console.log(channel);

  // selectors
  const {
    selectedWebChatChannel,
    webChatChannelDataLoading,
    webChatChannelListLoading,
    webChatChannelDataError,
    webChatChannelListError,
    webChatChannelList,
    unassignedTeams,
    unassignedTeamsLoading,
    unassignedTeamsError,
  } = useSelector((state) => state.Channel);
  const { currentBrand, featureFlags } = useSelector((state) => state.app);

  // useEffects
  useEffect(() => {
    if (webChatChannelDataError) {
      if (webChatChannelDataError?.data?.status === 403) {
        showErrorToast(toast, 'User not authorized to view this page');
      } else {
        showErrorToast(toast, 'Something went wrong');
      }
    }
  }, [webChatChannelDataError]);

  useEffect(() => {
    if (webChatChannelListError) {
      if (webChatChannelListError?.data?.status === 403) {
        showErrorToast(toast, 'User not authorized to view this page');
      } else {
        showErrorToast(toast, 'Something went wrong');
      }
    }
  }, [webChatChannelListError]);

  useEffect(() => {
    if (unassignedTeamsError) {
      if (unassignedTeamsError?.data?.status === 403) {
        showErrorToast(toast, 'User not authorized to view this page');
      } else {
        showErrorToast(toast, 'error fetching unassigned teams');
      }
    }
  }, [unassignedTeamsError]);

  useEffect(() => {
    // console.log({channel, webChatChannelList});

    if (channel && webChatChannelList) {
      const channelData = webChatChannelList.find(
        (item) => item.id === channel
      );
      if (channelData) {
        dispatch(
          getWebChatChannelData({
            channel: channel,
            brand_id: currentBrand?.brand_id,
          })
        );
      }
    }
  }, [webChatChannelList, channel]);

  if (!featureFlags?.webchat_feature) {
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button
            onClick={() => {
              navigate('/user/home');
            }}
            type="primary"
          >
            Back Home
          </Button>
        }
      />
    );
  }

  return (
    <div className="grid grid-cols-[minmax(250px,1fr)_minmax(650px,5fr)] gap-3 h-dvh *:rounded-lg  *:shadow-sm *:h-[calc(100dvh-50px)] overflow-hidden">
      <div className="bg-white overflow-auto">
        {webChatChannelListLoading ? (
          <div className="h-full flex items-center justify-center flex-col">
            <Loading3QuartersOutlined spin style={{ fontSize: '2rem' }} />
          </div>
        ) : (
          <div className="sticky top-0 bg-white">
            <Title className="p-4 pb-2" style={{ marginBottom: '0' }} level={5}>
              Channels List
            </Title>
            <Divider style={{ margin: '0' }} className="pb-4" />
          </div>
        )}
        <WebChatChannels />
      </div>
      <div className="bg-white overflow-auto">
        {webChatChannelDataLoading ? (
          <div className="h-full flex items-center justify-center flex-col">
            <Loading3QuartersOutlined spin style={{ fontSize: '2rem' }} />
          </div>
        ) : selectedWebChatChannel?.id ? (
          <WebChatChannelEditor type="edit" />
        ) : (
          <Empty
            className="h-full flex items-center justify-center flex-col"
            description={<Text>No Channel Selected</Text>}
          />
        )}
      </div>
    </div>
  );
};

export default WebChatChannel;
